import labels from "emun.cust/_labels";

export default {
  Id: "Id: Low to High",
  "-Id": "Id: High to Low",
  "CompanyName,Id": "Name: A to Z",
  "-CompanyName,Id": "Name: Z to A",
  "City,Id": "City: A to Z",
  "-City,Id": "City: Z to A",
  "State,Id": "State: A to Z",
  "-State,Id": "State: Z to A",
  "Zip,Id": "Zip: 0 - 9",
  "-Zip,Id": "Zip: 9 - 0",
  "SalesRepName,Id": "Rep: A to Z",
  "-SalesRepName,Id": "Rep: Z to A",
  "TerritoryName,Id": "Territory: A to Z",
  "-TerritoryName,Id": "Territory: Z to A",
  "RegionName,Id": "Region: A to Z",
  "-RegionName,Id": "Region: Z to A",
  "Status,CompanyName,Id": "Status: A to Z",
  "-Status,CompanyName,Id": "Status: Z to A"
};
